import { Label } from "@/components/ui/label";
import { useAllEvents, useQuoteTags } from "@/lib/queries";
import { TagInput } from "@/components/quotes/TagInput";
import { EventPicker } from "@/components/quotes/EventPicker";

export const QuoteLinksFields = ({ uid, tags, eventIds, onTags, onEvents, testid = "quote-links" }) => {
  const { data: events = [] } = useAllEvents(uid);
  const { data: known = [] } = useQuoteTags(uid);
  return (
    <div className="space-y-3" data-testid={testid}>
      <div className="space-y-1.5"><Label className="text-xs text-[#A8A090]">Tags</Label><TagInput value={tags} onChange={onTags} known={known} testid={`${testid}-tags`} /></div>
      {events.length > 0 && <div className="space-y-1.5"><Label className="text-xs text-[#A8A090]">Said at events</Label><EventPicker events={events} value={eventIds} onChange={onEvents} testid={`${testid}-events`} /></div>}
    </div>
  );
};
